import '../pages.css';
import { Link } from 'react-router-dom';

const Zirlux = () => {
    return (
        <div className="page product-detail">
            <section className="product-detail-hero">
                <div className="product-detail-hero-content">
                    <Link to="/products/fixed" className="back-link">← Back to Fixed Prosthetics</Link>
                    <h1>Zirlux®</h1>
                    <p className="product-tagline">Superior strength with seamless esthetics</p>
                </div>
            </section>

            <section className="product-detail-content">
                <div className="content-container">
                    <div className="product-section">
                        <h2>Description</h2>
                        <p>
                            Zirlux® restorations from <strong>AbELab</strong> utilize a solid zirconia substructure to achieve superior
                            strength and fracture resistance while supporting highly esthetic porcelain layering. This metal-free solution
                            provides a seamless, natural appearance.
                        </p>
                    </div>

                    <div className="product-two-column">
                        <div className="product-section">
                            <h2>Indications</h2>
                            <ul>
                                <li>Crowns and bridges</li>
                                <li>Implant-supported restorations</li>
                                <li>Limited space cases as an alternative to PFM</li>
                            </ul>
                        </div>

                        <div className="product-section">
                            <h2>Contraindications</h2>
                            <ul>
                                <li>Cases demanding perfect shade matching</li>
                                <li>Situations requiring strong adhesive retention</li>
                            </ul>
                        </div>
                    </div>

                    <div className="product-section">
                        <h2>Preparation, Cementation & Technical Notes</h2>
                        <p>Follow standard full-contour zirconia protocols.</p>
                    </div>

                    <div className="product-section product-codes">
                        <h2>Codes</h2>
                        <ul>
                            <li><strong>D2740</strong> – Crown, porcelain/ceramic substrate</li>
                            <li><strong>D6245</strong> – Pontic, porcelain/ceramic</li>
                            <li><strong>D6740</strong> – Abutment crown, porcelain/ceramic</li>
                        </ul>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Zirlux;
